import React, { Component } from "react"
import styled from "styled-components"
import { SECONDARY_TEXT, ACTIVE_TEXT } from "./consts/colors"
import TinySignUp from "./TinySignUp"

const SectionHeaderContentContainer = styled.div`
  position: relative;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 0px auto;
  width: ${props => props.width};
  min-height: ${props => props.height};
  max-width: 600px;

  h1 {
    margin-bottom: 15px;
  }

  p {
    margin: 10px 0px 25px 0px;
    width: calc(100% - 50px);
  }
`

const SectionHeaderContent = props => (
  <SectionHeaderContentContainer width={props.width} height={props.height}>
    <h1>{props.headline}</h1>
    <p>{props.copy}</p>
    <TinySignUp placeholder={props.placeholder} />
  </SectionHeaderContentContainer>
)

export default SectionHeaderContent



// WEBPACK FOOTER //
// ./src/components/SectionHeaderContent.js